// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3895da66","455":"58cf695e","977":"e74871c3"}[chunkId] + ".chunk.js";
};